module.exports = __webpack_public_path__ + "img/aia-title-tips.783cb7eb.png";